import { Pipe, PipeTransform } from '@angular/core';
import { AgendaQueueItemStatus } from '../models/agenda';

@Pipe({
    name: 'agendaQueueItemStatus',
    standalone: false
})
export class AgendaQueueItemStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const a = AgendaQueueItemStatus[value];
    if (a) {
      const b = a
        .replace(/([A-Z])/g, ' $1')
        .replace(a.substring(0, 1), a.substring(0, 1).toUpperCase());
      return b;
    }
    return '';
  }
}
